import React from "react";

class PurchaseGiftSuccess extends React.Component {
  render() {
    return (
      <div className="gift-success-container">
        <div className="main-container">
          <img
            src={require("../../images/confirmationCheckmark.png")}
            className="confirmation-checkmark"
          />
          <div className="header">Thanks for your purchase!</div>
          <div className="instructions">
            You should receive a copy of the email with a code that can be redeemed for app
            access in case you would like to print it.
          </div>
          <div className="instructions">
            The recipient will also receive an email with all the information they need to redeem the code at the chosen time.
          </div>
          <div className="bottom-text">
            If you do not receive one in the next 60 minutes, or if you have any
            questions, please contact support@trybe.do
          </div>
        </div>
      </div>
    );
  }
}

export default PurchaseGiftSuccess;



// WEBPACK FOOTER //
// ./src/components/payments/PurchaseGiftsuccess.js